import { useEffect } from 'react'
import './profile.css'
import { IoIosContact } from "react-icons/io";
import { setActivity, useProfile } from '../../Global/Index';
import { ToastContainer, toast } from 'react-toastify';
import ClipLoader from 'react-spinners/ClipLoader';
import { useTheme } from '@mui/material';


const override = {
    display: "block",
    margin: "10% auto",
    marginLeft: '50%'
};




const ProfilePage = () => {

    const theme = useTheme();
    useEffect(() => {
        setActivity('Profile Page');

    }, [])

    const { data: profileData, isLoading: isLoadingProfile, error: profileError } = useProfile();
    const isLoading = isLoadingProfile || profileError;
    const error = profileError;

    if (error) {
        if (error.response.status == "500") {
            toast.error('something went wrong. Please try again later!')
        } else if (error.response.status == '503') {
            toast.warn(error.response.message);
        } else if (error.response.status == '419') {
            window.location.href = "/Session-Expired"
        } else if (error.response.status == '401') {
            window.location.href = '/'
        }
    }

    let profiledata = profileData?.response?.data ?? null;

    return (
        <>
            <ToastContainer />
            <div className="maincontainer">
                <h2>Profile</h2>
                <div className="mainsubcontainer" style={{ backgroundColor: theme.palette.background.alt, color: theme.palette.primary.main }}>
                    {
                        isLoading ? (<ClipLoader
                            color="rgb(155,57,19)"
                            loading={true}
                            cssOverride={override}
                            size={30}
                            aria-label="Loading Spinner"
                            data-testid="loader"
                        />) : (<div className="profilePage">
                            {/* <div>{JSON.stringify(profiledata)}</div> */}
                            <div className="profilePage1">
                                <div className="subheading"><IoIosContact style={{ fontSize: '20px', color: ' rgba(227,57,54)' }} /> Personal Details</div>
                                <div className="details">
                                    <div className="personal details1">

                                        <div className="name">
                                            <p> Name</p>

                                            <h3>{profiledata.name === "" ? "NA" : profiledata.name}</h3>
                                        </div>
                                        <div className="DOB">
                                            <p>Date of Birth</p>
                                            <h3>{profiledata.dateofbirth === null ? "NA" : profiledata.dateofbirth}</h3>
                                        </div>
                                        <div className="gender">
                                            <p>Gender</p>
                                            <h3>{profiledata.gender === null || profiledata.gender === "" ? "NA" : profiledata.gender}</h3>
                                        </div>
                                         <div className="category">
                                            <p>CKYC Number </p>
                                            <h3>{(profileData.ckycnumber == ""|| profileData.ckycnumber=='NA' || profileData.ckycnumber==null)?"NA":profileData.ckycnumber}</h3>
                                        </div>

                                    </div>
                                    <div className="personal details2">
                                        {/* <div className="eKYC">
                                        <p>eKYC</p>
                                        <h3>No data from API</h3>
                                    </div> */}
                                        <div className="mobile">
                                            <p>Mobile No.</p>
                                            <h3>{profiledata.mobile}</h3>
                                        </div>

                                       
                                    </div>
                                </div>
                            </div>
                        </div>)
                    }
                </div>
            </div>
        </>
    )
}

export default ProfilePage 